import { Box, CircularProgress } from '@mui/material';

type GridLoadingOverlayProps = {
  visible: boolean;
};

export const GridLoadingOverlay = ({ visible }: GridLoadingOverlayProps) => {
  if (!visible) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: (theme) =>
          theme.palette.mode === 'dark' ? 'rgba(18, 18, 18, 0.72)' : 'rgba(255, 255, 255, 0.7)',
        zIndex: 20,
      }}
    >
      <CircularProgress color="primary" />
    </Box>
  );
};
